/** One tick per account the active client owns, filled for each one currently checked. */
export function AccountTicks({ count, total }: { count: number; total: number }) {
  return (
    <span style={{ display: 'flex', gap: 2 }}>
      {Array.from({ length: total }, (_, i) => (
        <span
          key={i}
          style={
            count > i
              ? { width: 5, height: 11, background: 'currentColor', display: 'inline-block' }
              : { width: 5, height: 11, border: '1px solid currentColor', opacity: 0.3, display: 'inline-block' }
          }
        />
      ))}
    </span>
  )
}
